import dayjs from "dayjs";
export const getMRZ = (mrz = "") => {
  try {
    const myRegexp = /P<(.*?)(<<<)/g;
    const match = myRegexp.exec(mrz) || [];
    const matchText = (match[1] || "").trim();
    const countryCode = matchText.slice(0, 3) || "";
    const name = matchText.slice(3);
    const [firstName, lastName] = name.split("<<");

    return {
      countryCode,
      firstName,
      lastName,
    };
  } catch (error) {
    return {
      countryCode: "",
      firstName: "",
      lastName: "",
    };
  }
};

export const convertMRZDate = (yymmdd = "") => {
  if (!yymmdd || yymmdd.length !== 6) return "";

  const year = parseInt(yymmdd.slice(0, 2));
  const month = parseInt(yymmdd.slice(2, 4)) - 1;
  const day = parseInt(yymmdd.slice(4, 6));

  const fullYear = parseInt(`${year < 50 ? "20" : "19"}${year}`);

  return dayjs(new Date(fullYear, month, day)).format("YYYY-MM-DD");
};
